export default "__VITE_ASSET__CADC5EBl__"